module.exports = __webpack_public_path__ + "static/media/draper.740613b1.svg";